// extracted by mini-css-extract-plugin
export var divider = "mobile-menu-module--divider--96fa9";
export var hasSubmenu = "mobile-menu-module--has-submenu--f9e6b";
export var menuItem = "mobile-menu-module--menu-item--c1836";
export var mobileNav = "mobile-menu-module--mobileNav--f9507";
export var navItemsWrapper = "mobile-menu-module--navItemsWrapper--dd2e8";
export var navMenuItem = "mobile-menu-module--navMenuItem--426bc";
export var opened = "mobile-menu-module--opened--c8511";
export var parentLink = "mobile-menu-module--parentLink--fd649";
export var socialWrapper = "mobile-menu-module--socialWrapper--5731f";
export var subMenu = "mobile-menu-module--sub-menu--87fc9";
export var submenuHeader = "mobile-menu-module--submenuHeader--207bf";
export var thirdlLevelSub = "mobile-menu-module--thirdlLevelSub--5690b";
export var toggleIcon = "mobile-menu-module--toggleIcon--d51c8";